"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCapabilities = getCapabilities;

var _initialState = require("@nextcloud/initial-state");

function getCapabilities() {
  try {
    return (0, _initialState.loadState)('core', 'capabilities');
  } catch (error) {
    console.debug('Could not find capabilities initial state fall back to _oc_capabilities');

    if (!('_oc_capabilities' in window)) {
      return {};
    }

    return window['_oc_capabilities'];
  }
}
//# sourceMappingURL=index.js.map